export default "__VITE_ASSET__BY8M6Tpa__"